import 'redux-saga/effects';
import { DAEMON } from '@dbh/redux-extra';
import { REDUX_AND_SAGA_KEY } from './index.js';
import 'lodash/last';
import 'immutable';
import 'date-fns/format';
import 'react-router-redux';
import '@dbh/dates';
import '@dbh/redux-route-internals';
import '@dbh/ssr-data-redux';
import 'prop-types';
import '@dbh/with-conforms-to-for-production-www';
import '@dbh/cookie-keys';
import '@dbh/cookies';
import 'reselect';
import '@dbh/lodash-extra';
import '@dbh/reselect-extra';

function*loggerRootSaga(){}const injectedSagaConfiguration={key:REDUX_AND_SAGA_KEY,mode:DAEMON};

export { loggerRootSaga as default, injectedSagaConfiguration };
